import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { EmployeeDashboard } from '@/components/EmployeeDashboard';
import { AdminDashboard } from '@/components/AdminDashboard';
import { Navigation } from '@/components/Navigation';
import { Loader2 } from 'lucide-react';

const Index = () => {
  const { user, loading, userRole } = useAuth();
  const navigate = useNavigate();
  const [currentView, setCurrentView] = useState<'employee' | 'admin'>('employee');

  useEffect(() => {
    if (!loading && !user) {
      navigate('/auth');
    }
  }, [user, loading, navigate]);

  useEffect(() => {
    // Set default view based on user role
    if (userRole === 'admin' || userRole === 'manager' || userRole === 'bookkeeper') {
      setCurrentView('admin');
    } else {
      setCurrentView('employee');
    }
  }, [userRole]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-surface flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return null; // Will redirect to auth
  }

  const handleViewChange = (view: 'employee' | 'admin') => {
    // Only allow admin/manager access to admin view
    if (view === 'admin' && userRole !== 'admin' && userRole !== 'manager' && userRole !== 'bookkeeper') {
      return;
    }
    setCurrentView(view);
  };

  return (
    <div className="relative">
      <Navigation 
        currentView={currentView} 
        onViewChange={handleViewChange}
        userRole={userRole}
      />
      
      <div className="pt-16">
        {currentView === 'employee' ? (
          <EmployeeDashboard />
        ) : (
          <AdminDashboard />
        )}
      </div>
    </div>
  );
};

export default Index;
